


















































import {Component, Vue} from "vue-property-decorator";
import axios from 'axios';
import {MutationList as NavMutations} from "@/store/modules/navigation/mutation-list";
import {MutationList as ModalMutations} from "@/store/modules/modal/mutation-list";
import {MutationList as UserMutations} from "@/store/modules/user/mutation-list";
import {isAuthenticated} from "@/helpers";

@Component
export default class ModalAuthorization extends Vue{

    private rootNamespace = 'root/';
    private modalNamespace = 'modal/';
    private userNamespace = 'user/';

    private data = {
        name: '',
        password: ''
    }

    async sendRequest(){
        await axios.post('https://dev.palmamedical.lv/api/rest/user/accesstoken', this.data)
        .then(response => {
            this.$store.commit(`${this.userNamespace}${UserMutations.SET_USER}`, response.data);
            this.$store.commit(`${this.userNamespace}${UserMutations.SET_AUTHENTICATED_TO_TRUE}`);
        })
        .catch(e => {
            console.log(e);
        });
        await this.$router.push(this.$store.state.navigation.targetRoute);
    }

    back(){
        this.$store.commit(`${this.modalNamespace}${ModalMutations.SET_AUTH_MODAL_VISIBILITY_FALSE}`);
    }

    // just check if user is authenticated. Switches between form and message
    get logged() {
        return isAuthenticated();
    }

    get visible(): boolean {
        return this.$store.getters[`${this.modalNamespace}isAuthVisible`]
    }

}
